module.exports = __webpack_public_path__ + "img/step3.86064911.png";